import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "arrayFilter",
    standalone: false
})
export class ArrayFilterPipe implements PipeTransform {
  transform(items: any[], allowedValues: any[], key: string): any[] {
    if (!items || !allowedValues?.length || !key) return [];

    return items.filter((it) => {
      return allowedValues.includes(it[key]);
    });
  }
}
